import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import LOOutcomeModalCst from "@components/LOOutcomeModalCst";
import CourseWizard from "../Course/CourseWizard";
import { useSubmitCourseV2 } from "../Course/hooks/useSubmitCourseV2";
import { CourseWizardData, EMPTY_COURSE_DATA } from "../Course/types";

const AddCourse: React.FC = () => {
  const { t: tOutcome } = useTranslation("lo-outcome-modal");
  const navigate = useNavigate();
  const { id: corporateId = "" } = useParams();
  const catalogUrl = `/v2/corporate/${corporateId}/detail/catalog`;

  const { submit: submitCourse, isSubmitting } = useSubmitCourseV2({
    corporateId,
  });

  const [successOpen, setSuccessOpen] = useState(false);

  const handleComplete = async (data: CourseWizardData) => {
    try {
      await submitCourse(data);
      setSuccessOpen(true);
    } catch (error) {
      console.error("[wizard-course] publish failed", error);
      throw error;
    }
  };

  return (
    <>
      <CourseWizard
        initialData={EMPTY_COURSE_DATA}
        onComplete={handleComplete}
        isSubmitting={isSubmitting}
      />
      <LOOutcomeModalCst
        open={successOpen}
        entityType="course"
        mode="add"
        associationOptions={[
          {
            key: "path",
            title: tOutcome("options.path.title"),
            description: tOutcome("options.path.description"),
          },
        ]}
        onAssociate={() => {
          // TODO: navigare al wizard percorso con il corso pre-selezionato???
          // Per ora si torna al catalog.
          navigate(catalogUrl);
        }}
        onDismiss={() => navigate(catalogUrl)}
      />
    </>
  );
};

export default AddCourse;
